import type { ThemeConfig } from 'antd/es/config-provider/context';

const components: ThemeConfig['components'] = {
  Layout: {
    colorText: '#fff',
    colorBgContainer: '#222',
  },
  Modal: {
    borderRadiusLG: 20,
  },
  Button: {
    controlHeight: 36,
  },
  Input: {
    controlHeight: 36,
  },
  DatePicker: {
    controlHeight: 36,
  },
  Select: {
    controlHeight: 36,
  },
};

export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#01CFD0',
    colorLink: '#01CFD0',
    colorLinkHover: '#01CFD0',
    colorError: '#ea6357',
    colorErrorBorderHover: '#ea6357',
    colorBgMask: 'rgba(0,0,0,0.06)',
  },
  components,
};
